export const isAuthenticated = state => {
  return !!state.session.user && !!state.session.accessToken;
};

// roles
export const isAdmin = state => {
  return state.session.user && state.session.user.roles
    ? state.session.user.roles.includes("admin")
    : false;
};

export const sessionExpired = state => {
  let now = new Date();
  let expiresAt = new Date(state.session.expiresAt * 1000);
  return !!(now > expiresAt);
};

export const bearerToken = state => {
  return `Bearer ${state.session.accessToken}`;
};
